(function () {
  const root = document;
  const mobileToggle = root.querySelector('[data-pc-mobile-toggle]');
  const sidebar = root.querySelector('.pc-sidebar');

  // Mobile: open/close sidebar (filters + sort)
  if (mobileToggle && sidebar) {
    mobileToggle.addEventListener('click', () => {
      sidebar.classList.toggle('is-open');
      mobileToggle.setAttribute(
        'aria-expanded',
        sidebar.classList.contains('is-open') ? 'true' : 'false'
      );
    });
  }

  // Auto-submit on sort change (keeps UX modern)
  root.querySelectorAll('.pc-sort__select').forEach((select) => {
    select.addEventListener('change', () => {
      const formId = select.getAttribute('form');
      const form = formId ? root.getElementById(formId) : select.closest('form');
      if (form) form.submit();
    });
  });

  // Handle pagination and page navigation
  root.querySelectorAll('.pc-pagination__link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const url = link.getAttribute('href');
      // You can either use window.location to change the page or AJAX to load content dynamically
      window.location.href = url; // This refreshes the page based on the clicked page number
    });
  });

  // Optional: auto-apply filters when checkbox changes (premium UX)
  // Enable by setting data-auto-submit="true" on form in Liquid if you want it.
  root.querySelectorAll('.pc-filters[data-auto-submit="true"] input[type="checkbox"]').forEach((cb) => {
    cb.addEventListener('change', () => {
      const form = cb.closest('form');
      if (form) form.submit();
    });
  });
})();
